import {NgModule} from '@angular/core';
import {EntityDataService, EntityServices} from '@ngrx/data';
import {SaleProductRepository} from './impl/service/ngrx/SaleProduct.repository';
import {SaleProductDataService} from './impl/service/ngrx/SaleProductData.service';

@NgModule({
})
export class SaleProductModule {
    constructor(entityDataService: EntityDataService,
                entityServices: EntityServices,
                repository: SaleProductRepository,
                dataService: SaleProductDataService,
    ) {

        entityDataService.registerServices({
            SaleProduct: dataService,
        });

        entityServices.registerEntityCollectionServices({
            SaleProduct: repository,
        });

        //  errorMessages.set('PRODUCT_SAVE_CODE_ALREADY_USED', 'Un produit avec ce code existe déjà');
    }
}
